import React from 'react';
import PropTypes from 'prop-types';
import { TextField, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import styles from './RuleDisplay.module.css';

const RuleDisplay = ({ rule, ruleType, ruleDetails, handleEditRuleClick, canEdit }) => {
  return (
    <div className={styles.ruleDisplayContainer}>
      <div className={styles.ruleLabel}>
        {ruleType}
        {canEdit && (
        <IconButton
          aria-label="Edit Rule"
          size="small"
          className={styles.editIcon}
          onClick={() => handleEditRuleClick(rule)} // Use the rule prop here
        >
          <EditIcon fontSize="small" />
        </IconButton>
        )}
      </div>
      <TextField
        className={styles.textBox}
        variant="outlined"
        value={ruleDetails}
        InputProps={{
          readOnly: true,
        }}
      />
    </div>
  );
};

RuleDisplay.propTypes = {
  rule: PropTypes.object.isRequired, // Ensure rule is an object
  ruleType: PropTypes.string, // Make ruleType optional
  ruleDetails: PropTypes.string, // Make ruleDetails optional
  handleEditRuleClick: PropTypes.func.isRequired, // Ensure the handler is passed
  canEdit: PropTypes.bool,
};

RuleDisplay.defaultProps = {
  ruleType: "Unknown Type", // Default value for ruleType
  ruleDetails: "No details provided", // Default value for ruleDetails
  canEdit: false, // Default to not editable
};

export default RuleDisplay;

